import { CAPABILITY_KEYS } from '../constants/capabilities';
import { hasLoadedCapabilities } from '../utils/capabilityUtils';
import { useSubscriptionPermission } from './useSubscriptionPermission';
import { useCapability } from './useCapability';

export const getFormsDetailFallbackPath = () => '/client-portal-forms';

export const isFormsDetailPath = (path = '') => {
  return path.startsWith('/client-portal/forms/');
};

export const useFormsAccess = () => {
  const { hasPermission, permissions } = useSubscriptionPermission('forms');
  const capability = useCapability(CAPABILITY_KEYS.FORMS);
  const permissionsLoaded = Array.isArray(permissions);
  const capabilitiesLoaded = hasLoadedCapabilities(capability.capabilities);
  const isResolved = permissionsLoaded && capabilitiesLoaded;

  return {
    hasSubscriptionPermission: hasPermission,
    canViewForms: hasPermission && capability.visible,
    canInteractWithForms: hasPermission && capability.accessible,
    isReadOnlyForms: hasPermission && capability.isRestricted,
    permissionsLoaded,
    capabilitiesLoaded,
    isResolved,
    ...capability,
  };
};
